<template>
  <div class="row">
    <div class="col-xl-12">
      <h2 class="text-dark">Gestión de Productos</h2>
    </div>
    <div class="col-lg-4 col-sm-4">
      <div class="card shadow">
        <div class="card-body p-0" v-if="loadingProducts">
          <my-spinner :loading="loadingProducts" />
        </div>

        <div v-show="!loadingProducts" class="card-body text-center">
          <p>Para comenzar, selecciona un producto del listado</p>

          <div class="form-group mb-2">
            <select
              class="form-control"
              id="exampleFormControlSelect1"
              @change="setSelectedProduct()"
              v-model="idProduct"
            >
              <option value="0">Seleccionar Producto</option>
              <template v-for="product in products">
                <option
                  :key="product.id"
                  :value="product.id"
                >{{product.name}} {{ !product.active ? "(Inactivo)":"" }}</option>
              </template>
            </select>
          </div>
          <div v-if="actions.post">
            <p>ó</p>
            <button class="btn btn-success btn-xs" @click="toggleForm">
              <i class="fa fa-plus-circle text-success"></i> crea uno nuevo
            </button>
          </div>
        </div>
      </div>
      <div class="card card-body shadow text-muted text-xs mt-3" v-if="selectedProduct.id > 0">
        <p class="text-dark m-0 mb-2">Detalles</p>
        <p class="m-0 text-xs text-primary">Creado por:</p>
        <span>{{selectedProduct.user}}</span>
        <p class="m-0 text-xs text-primary">Fecha:</p>
        <span class="text-capitalice">{{selectedProduct.create_date | formatDate}}</span>
        <template v-if="selectedProduct.update_user">
          <hr class="m-0 text-xs my-2 text-muted" />
          <p class="m-0 text-xs text-primary">Editado por:</p>
          <span>{{selectedProduct.update_user}}</span>
          <p class="m-0 text-xs text-primary">Fecha:</p>
          <span class="text-capitalice">{{selectedProduct.update_date | formatDate}}</span>
        </template>
      </div>
    </div>
    <div class="col-lg-8 col-sm-8 fadeInUp" v-if="showForm">
      <div class="card border-0">
        <div
          class="card-header text-white"
          v-text="selectedProduct.id == 0 ? 'Crear nuevo Producto': 'Estás en modo edición'"
          :class="selectedProduct.id == 0 ? 'bg-success': 'bg-info'"
        ></div>

        <div class="card-body p-relative">
          <form @submit.prevent="handleSetProduct">
            <div class="alert alert-secondary shadow" v-if="!selectedProduct.active">
              <h4>
                <i class="fa fa-exclamation-triangle mr-2 text-danger fadeIn"></i>
                Producto configurado como
                <u>Inactivo</u>
                <template v-if="selectedProduct.active != tmpProduct.active">
                  <br />
                  <small class="text-muted text-xs">Debes guardar cambios para hacerlo efectivo.</small>
                </template>
              </h4>
            </div>
            <div class="form-group">
              <label class="text-xs text-muted" for>Nombre del Producto</label>
              <input
                :disabled="loading"
                type="text"
                class="form-control"
                v-model="selectedProduct.name"
              />
            </div>
            <div class="form-group">
              <label class="text-xs text-muted" for>Descripción breve</label>
              <textarea
                class="form-control"
                cols="30"
                rows="2"
                maxlength="200"
                v-model="selectedProduct.description"
                placeholder="Descripción breve"
              ></textarea>
            </div>
            <div class="form-group"
              v-if="authObj.setSpecialsAccess(this.$route.name, 'service_external_id')">
              <label class="text-xs text-muted" for>Código Externo</label>
              <input

                :disabled="selectedProduct.id > 0 || loading"
                type="text"
                class="form-control"
                v-model="selectedProduct.external_code"
              />
            </div>

            <div class="form-group">
              <label class="text-xs text-muted" for>Cant. días de actividad</label>
              <input
                style="width: 150px;"
                :disabled="loading"
                min="0"
                max="365"
                maxlength="3"
                type="number"
                class="form-control"
                v-model="selectedProduct.activeDays"
              />
              <span
                class="text-help text-xs text-muted d-block mt-2"
              >Días de vigencia para los avisos asociados a este producto.</span>
              <span
                class="text-help text-xs text-danger d-block mt-2"
                v-if="!validActiveDays"
              >El valor debe ser de 1 a 180 días.</span>
            </div>

            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input
                  class="custom-control-input"
                  id="fieldMultiple"
                  type="checkbox"
                  v-model="selectedProduct.multiple"
                  :disabled="loading || !actions.put"
                />
                <label class="custom-control-label" for="fieldMultiple">Multiple asignación</label>
              </div>
              <span
                class="text-help text-xs text-muted"
              >Se puede asignar más de una vez simultáneamente.</span>
            </div>
            <div class="form-group">
              <div class="custom-control custom-checkbox mb-3">
                <input
                  class="custom-control-input"
                  id="customCheck3"
                  type="checkbox"
                  v-model="selectedProduct.active"
                  :disabled="loading || !actions.put"
                />
                <label class="custom-control-label" for="customCheck3">Activar este producto</label>
              </div>
            </div>
            <div class="form-group">
              <div class="custom-control custom-checkbox mb-3">
                <input
                  class="custom-control-input"
                  id="controlPanel"
                  type="checkbox"
                  v-model="selectedProduct.control_panel"
                  :disabled="loading || !actions.put"
                />
                <label class="custom-control-label" for="controlPanel">Activar en control panel</label>
              </div>
            </div>
            <div class="form-group text-right">
              <div class="alert alert-danger text-center" v-if="error">Hubo un error</div>
              <button
                type="button"
                class="btn btn-secondary"
                @click="cancelEdition"
                :disabled="loading"
              >Cancelar</button>

              <button
                v-if="actions.put || actions.post"
                type="submit"
                :disabled="!validProduct || loading"
                class="btn"
                v-text="selectedProduct.id == 0 ? 'Guardar': 'Actualizar'"
                :class="selectedProduct.id == 0 ? 'btn-success': 'btn-info'"
              >Guardar</button>
            </div>
          </form>
        </div>
      </div>
      <hr />
    </div>
    <div class="col-sm-12">
      <template v-if="selectedProduct.id > 0">
        <ProductDetails :actions="actions" :product="selectedProduct" />
      </template>
    </div>
  </div>
</template>
<script>
import { Product } from "./models/model";
import Auth from "@/helpers/middleware";
import utils from "@/helpers/utils";
import dealersService from "@/services/dealers.services";
import sysMsgs from "@/helpers/system.message";
import ProductDetails from "./ProductDetails";
export default {
  name: "Products",
  components: {
    ProductDetails
  },
  data() {
    return {
      showForm: false,
      actions: Auth.getActions(this.$route.name),
      selectedProduct: new Product(Auth.getUser().email),
      tmpProduct: new Product(Auth.getUser().email),
      authObj: Auth,
      idProduct: 0,
      error: false,
      loading: false,
      products: [],
      loadingProducts: false
    };
  },
  created() {
    this.getProducts();
  },
  filters: {
    formatDate(val) {
      return utils.formatDateTime(val);
    }
  },
  methods: {
    getProducts() {
      this.loadingProducts = true;
      dealersService.admin
        .getProducts()
        .then(response => {
          this.products = response.data;
        })
        .catch(error => {
          console.log("error", error);
        })
        .finally(() => {
          this.loadingProducts = false;
        });
    },
    cancelEdition() {
      this.idProduct = 0;
      this.showForm = false;
      this.selectedProduct = new Product(Auth.getUser().email);
      this.tmpProduct = new Product(Auth.getUser().email);
    },
    setSelectedProduct() {
      let product = this.products.find(product => product.id == this.idProduct);

      if (product) {        
        this.selectedProduct = { ...product };
        this.tmpProduct = { ...product };
        this.showForm = true;
      } else {
        this.selectedProduct = new Product(Auth.getUser().email);
        this.tmpProduct = new Product(Auth.getUser().email);
        this.showForm = false;
      }

      console.log(this.selectedProduct)
    },
    handleSetProduct() {
      if (!this.validProduct) {
        sysMsgs.getMessage(
          "Verifíca todos los campos antes de guardar.",
          "error"
        );
        return;
      }
      let msg = {};
      msg.text = this.selectedProduct.id == 0 ? "crear un nuevo" : "editar el";
      msg.type = this.selectedProduct.id == 0 ? "question" : "warning";
      sysMsgs
        .getConfirm(
          `¿Está seguro que quiere ${msg.text} producto?`,
          msg.type,
          "Confirmar acción"
        )
        .then(result => {
          if (result.value) {
            this.setProduct();
          }
        });
    },
    setProduct() {
      this.loading = true;
      const _this = this;
      let selectedItem = {... this.selectedProduct};
      selectedItem.user = Auth.getUser().email;
      dealersService.admin
        .setProduct(selectedItem)
        .then(response => {
          if (this.selectedProduct.id > 0) {
            let products = _this.products;
            let productIndex = _this.products.findIndex(
              product => product.id == _this.selectedProduct.id
            );
            products[productIndex] = { ...this.selectedProduct };
            this.tmpProduct = { ...this.selectedProduct };
            _this.products = [...products];
            this.selectedProduct = response.data;
          } else {
            this.selectedProduct = response.data;
            this.tmpProduct = response.data;
            this.products.push(response.data);
          }

          sysMsgs.getMessage("Realizado con éxito.", "success");
        })
        .catch(error => {
          console.log("error", error);
          sysMsgs.getResponseMessage(error.response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggleForm() {
      this.idProduct = 0;
      this.selectedProduct = new Product(Auth.getUser().email);
      this.showForm = true;
    }
  },
  computed: {
    validName() {
      return this.selectedProduct.name.trim().length > 0;
    },
    validActiveDays() {
      return (
        parseInt(this.selectedProduct.activeDays) >= 0 &&
        parseInt(this.selectedProduct.activeDays) <= 180
      );
    },
    validProduct() {
      return this.validName && this.validActiveDays;
    }
  }
};
</script>
<style lang="scss">
.tab-pane {
  outline: none !important;
}
</style>